import { render } from "./ComponentDialog.vue?vue&type=template&id=827a0c2e&ts=true"
import script from "./ComponentDialog.vue?vue&type=script&lang=ts"
export * from "./ComponentDialog.vue?vue&type=script&lang=ts"

import "./ComponentDialog.vue?vue&type=style&index=0&id=827a0c2e&lang=less"

import exportComponent from "/root/.jenkins/workspace/test-saas-doctor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__